import { useState } from 'react';
import supabase from '../supabaseClient';
import { addCsrfHeader } from '../utils/csrfUtils';

export const useCompleteUserSetup = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const completeUserSetup = async (preferences, pgUserId) => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Get the current session for the auth token
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session?.access_token) {
        throw new Error('No valid session found');
      }

      // Add CSRF token to headers along with auth token
      const headers = await addCsrfHeader({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      });

      const response = await fetch(`/api/v1/users/setup_complete/${pgUserId}`, {
        method: 'POST',
        headers,
        body: JSON.stringify(preferences)
      });

      console.log("setting app_user.setup_complete to true");

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to complete user setup');
      }

      const data = await response.json();
      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { completeUserSetup, isLoading, error };
};
